import { CREATENOTE, GETNOTE, DELETENOTE, UPDATENOTE } from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETNOTE:
      return {
        ...state,
        noteList: action.payload.data,
      };
    case UPDATENOTE:
      return {
        ...state,
        noteUpdateStatus: action.payload.success,
      };

    case DELETENOTE:
      return {
        ...state,
        noteDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
